import React, { useId } from "react"

import { Grid } from "@mui/material"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { ErrorStyle } from "../../SignAsTeacher.styles"
import { TextFieldStyle } from "../PersonalForm.styles"

interface IProps {
  name: string
  label: string
  handleFunction: (event: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  invalid: boolean
}

const FormText = ({ name, handleFunction, value, invalid, label }: IProps) => {
  const methods = useFormContext()
  const { t } = useTranslation()
  const errorId = useId()

  const errorType =
    name === "first_name"
      ? methods.formState.errors?.first_name?.type
      : methods.formState.errors?.last_name?.type

  const errorMessage =
    errorType === "required"
      ? t("validations.fieldIsRequired")
      : errorType === "min"
        ? t("validations.enterMinChars_other", { count: 2 })
        : ""

  return (
    <Grid size={{ tablet: 6, mobile: 12 }}>
      <TextFieldStyle
        label={t(`noAuthFlow.${label}`)}
        {...methods.register(name, {
          onChange: (event) => handleFunction(event),
        })}
        name={name}
        value={value}
        invalid={invalid}
        error={!!errorMessage}
        inputProps={{
          "aria-invalid": !!errorMessage,
          ...(errorMessage && { "aria-describedby": errorId }),
        }}
      />
      {!!errorMessage && (
        <ErrorStyle id={errorId} role="alert">
          {errorMessage}
        </ErrorStyle>
      )}
    </Grid>
  )
}

export default FormText
